import { useQuery } from '@tanstack/react-query';
import { getShipLedger } from '../api/shipApi';
import type { ShipLedgerRow } from '../constants/ship.logic';

/**
 * A1 원장 행(간트 자재파트너 라벨·입고 완료 사진 표시용). 키 ['ship','ledger',scheduleId].
 * [자재파트너] 또는 [발주·입고] 칩이 켜져 있을 때만 enabled. 항상 최신, 오류는 isError 로 노출.
 */
export function useShipLedger(scheduleId: number | null | undefined, enabled: boolean) {
  return useQuery<ShipLedgerRow[]>({
    queryKey: ['ship', 'ledger', scheduleId],
    queryFn: () => getShipLedger(scheduleId as number),
    enabled: enabled && scheduleId != null,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
}
